import {
  DirectionsCar,
  Headphones,
  Medication,
  MonitorOutlined,
  Restaurant,
} from '@mui/icons-material';

import type { RecallType } from './interfaces';

export type RecallCardFieldRowKey =
  | 'recallDate'
  | 'severity'
  | 'recallSubType'
  | 'options'
  | 'affectedLocations';

export const RECALL_CARD_FIELDS: Array<{
  label: string;
  key: RecallCardFieldRowKey;
}> = [
  { label: 'Recall date:', key: 'recallDate' },
  { label: 'Severity:', key: 'severity' },
  { label: 'Type:', key: 'recallSubType' },
  { label: 'Options:', key: 'options' },
  { label: 'Affected locations:', key: 'affectedLocations' },
];

export const RECALL_TYPE_ICON: Record<RecallType, typeof Medication> = {
  drugs: Medication,
  food: Restaurant,
  'medical devices': MonitorOutlined,
  vehicle: DirectionsCar,
  'consumer product': Headphones,
};

export const RECALLS_PILLS = [
  'Vehicle',
  'Food',
  'Drugs',
  'Medical Devices',
  'Consumer Products',
] as const;

export type RecallsPill = (typeof RECALLS_PILLS)[number];

export interface RecallsFieldConfig {
  name: string;
  type: 'select' | 'text';
  options?: { value: string; label: string }[];
  placeholder?: string;
}

export interface RecallsPillConfig {
  searchTypeOptions: { value: string; label: string }[];
  fieldConfigs?: RecallsFieldConfig[];
}

export const RECALLS_SORT_OPTIONS_BASE = [
  { value: 'date_desc', display: 'Newest' },
  { value: 'date_asc', display: 'Oldest' },
] as const;

export const RECALLS_SORT_OPTION_SEVERITY = {
  value: 'severity_desc',
  display: 'Severity',
} as const;

export type RecallsSortValue =
  | (typeof RECALLS_SORT_OPTIONS_BASE)[number]['value']
  | (typeof RECALLS_SORT_OPTION_SEVERITY)['value'];

export function getRecallsSortOptions(includeSeverity: boolean): Array<{
  value: string;
  display: string;
}> {
  if (!includeSeverity) {
    return [...RECALLS_SORT_OPTIONS_BASE];
  }
  return [...RECALLS_SORT_OPTIONS_BASE, RECALLS_SORT_OPTION_SEVERITY];
}

export const RECALLS_PILL_CONFIG: Record<RecallsPill, RecallsPillConfig> = {
  Vehicle: {
    searchTypeOptions: [
      { value: 'LICENSE_PLATE', label: 'License Plate' },
      { value: 'VIN', label: 'VIN' },
      { value: 'YEAR_MAKE_MODEL', label: 'Year, Make, Model' },
    ],
  },
  Food: {
    searchTypeOptions: [
      { value: 'company_or_product', label: 'Company or Product' },
      { value: 'recall_number', label: 'Recall Number' },
    ],
  },
  Drugs: {
    searchTypeOptions: [
      { value: 'company_or_product', label: 'Company or Product' },
      { value: 'recall_number', label: 'Recall Number' },
    ],
  },
  'Medical Devices': {
    searchTypeOptions: [
      { value: 'company_or_product', label: 'Company or Product' },
      { value: 'recall_number', label: 'Recall Number' },
    ],
  },
  'Consumer Products': {
    searchTypeOptions: [
      { value: 'company_or_product', label: 'Company or Product' },
      { value: 'recall_number', label: 'Recall Number' },
    ],
  },
};
